import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import type { PaletteOptions } from "@mui/material/styles";

// Extend the Palette interface to include the financialClearance colors.
declare module "@mui/material/styles" {
  interface PaletteOptions {
    fc?: {
      primary: string;
      dark: string;
      muted: string;
      mutedLight: string;
      background: string;
      border: string;
    };
  }
}

// Create a theme instance.
export const theme = createMuiTheme({
  components:{
    MuiDrawer:{styleOverrides:{paper:{backgroundColor:'#162346',color:'white'}}},
    MuiAppBar:{styleOverrides:{root:{backgroundColor:'white', color:'gray'}}},
    MuiTextField:{
      defaultProps:{size:'medium',InputLabelProps:{shrink:true}, InputProps:{style:{height:40, fontSize:16}}},
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff'
          }
        }
      }
    },
    // MuiInputLabel: {styleOverrides: {root: {fontSize: '1.25rem', },},},
    MuiCard:{styleOverrides:{root:{borderRadius:10, padding:10, minWidth:'300px', boxShadow:'0 0 10px 0 rgba(100,100,100,0.3)'}}},
    MuiCardHeader:{styleOverrides:{root:{borderBottom:'3px solid #162346', padding:5, color:'#162346', marginBottom:15}}},
    MuiButton:{styleOverrides:{root:{borderRadius:5, margin:'5px', padding:7, borderWidth:'2px', fontWeight:'800', minWidth:'100px'}}},
  },
  palette: {
    primary: {
      main: '#162346',
    },
    success: {
      main: '#62BCBD',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    }, 
     background: {
      default: '#fff',
    },
    fc: {
      primary: '#3b82f6',
      dark: '#1e293b',
      muted: '#64748b',
      mutedLight: '#94a3b8',
      background: '#f8fafc',
      border: '#e2e8f0',
    },
  },
});

/** Financial Clearance module color palette (derived from theme.palette.fc for convenience). */
export const fcColors = {
  primary: '#3b82f6',
  dark: '#1e293b',
  muted: '#64748b',
  mutedLight: '#94a3b8',
  background: '#f8fafc',
  border: '#e2e8f0',
} as const;